import { render } from "./MTA2Praxis.vue?vue&type=template&id=3e9d3202"
import script from "./MTA2Praxis.vue?vue&type=script&lang=js"
export * from "./MTA2Praxis.vue?vue&type=script&lang=js"

import "./MTA2Praxis.vue?vue&type=style&index=0&id=3e9d3202&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__